{
  "eyebrow": "法的情報",
  "lastUpdated": "最終更新日：{date}",
  "seeAlso": "関連ページ：",
  "linkTerms": "利用規約",
  "linkPrivacy": "プライバシーポリシー",
  "linkCookies": "Cookieポリシー",
  "linkBuyerTerms": "購入者規約",
  "linkSellerAgreement": "販売者契約",
  "linkRefunds": "返金・紛争解決",
  "terms": {
    "title": "利用規約",
    "intro": "本利用規約（以下「本規約」）は、お客様とEngland &amp; Walesで登録された会社であるBidNova Auctions Ltd（以下「当社」）との間で締結される拘束力のある契約です。bidnovaauctions.uk（以下「本プラットフォーム」）への登録、閲覧、入札または出品を行うことにより、お客様は本規約に同意したものとみなされます。",
    "s1.h": "1. 当社および本契約について",
    "s1.p": "当社は、主にポケモンカードを対象とした鑑定済み・未鑑定トレーディングカードのオンラインオークションプラットフォームを運営しています。当社は買主と売主の仲介者として行動し、売買契約の当事者ではありませんが、売主に代わって代金を収受し、取引完了まで保管します。本規約はEngland &amp; Walesの法律に準拠し、England &amp; Wales裁判所が専属的管轄権を有します。",
    "s2.h": "2. 利用資格およびアカウント登録",
    "s2.li1": "18歳以上であり、英国法上契約を締結する法的能力を有している必要があります。",
    "s2.li2": "正確な登録情報を提供し、常に最新の状態に保つ必要があります。",
    "s2.li3": "アカウント内のすべての活動について責任を負い、パスワードを秘密に保つ必要があります。",
    "s2.li4": "登録時に本規約および当社の<a href=\"/legal/privacy\">プライバシーポリシー</a>に同意する必要があります。",
    "s2.li5": "当社は、本規約に違反した、不正行為を行った、または他の利用者に損害を与えたアカウントを停止または解除することがあります。",
    "s3.h": "3. オークション — 入札の仕組み",
    "s3.li1": "すべての入札は、当該ロットを入札額（設定された最低落札価格を条件とする）で購入する法的拘束力のある申込みです。",
    "s3.li2": "入札は一度行うと撤回できません。履行できない入札を行うことは本規約違反となります。",
    "s3.li3": "入札額は、現在の入札額にロットに表示された最低入札単位を加えた額以上でなければなりません。",
    "s3.li4": "売主は最低落札価格を設定できます。入札がこれに達しない場合、売買契約は成立しません。",
    "s3.li5": "駆け込み入札（スナイピング）を防止するため、終了2分前に行われた入札はオークションを2分間延長します。",
    "s3.li6": "売主は、自ら直接またはは第三者を通じて自身のオークションに入札してはなりません（「サクラ入札」は禁止されています）。",
    "s3.li7": "落札額が最低落札価格に達した場合、買主と売主との間に拘束力のある契約が成立します。",
    "s4.h": "4. 支払いおよびプラットフォーム手数料",
    "s4.li1": "すべての価格および手数料は英ポンド（GBP、£）建てです。",
    "s4.li2": "落札者は、当社のStripeチェックアウトを通じて72時間以内に支払いを完了する必要があります。",
    "s4.li3": "当社は売主に代わって代金を収受し、配達確認までこれを保管します。",
    "s4.li4": "当社のプラットフォーム手数料は落札額の8%であり、売主への支払い前に控除されます。出品料、月額料金、サブスクリプション料金は一切なく、手数料は販売成立時のみ発生します。",
    "s4.li5": "決済処理はStripe Payments UK Ltdが行い、お客様はStripeの規約にも同意するものとします。",
    "s4.li6": "支払いを怠った場合、取引の取消し、アカウントへの否定的評価、およびアカウント停止につながることがあります。",
    "s5.h": "5. 配送、追跡、および買主による確認",
    "s5.li1": "売主は支払い確認後5営業日以内に発送し、追跡番号をアップロードする必要があります。",
    "s5.li2": "英国内への発送はすべて追跡・署名受領サービス（例：Royal Mail Special Delivery）を使用する必要があります。",
    "s5.li3": "買主は商品を受け取り検査した後、プラットフォーム上で配達を確認する必要があります。",
    "s5.li4": "配達後72時間以内に異議申立てが行われない場合、注文は自動的に承認されたものとみなされます。",
    "s6.h": "6. 購入者保護",
    "s6.p": "お客様は個人または事業者である売主から購入するため、Consumer Rights Act 2015に基づく法定権利は売主が事業者である場合にのみ適用されます。これに加え、当社はすべての購入に対して以下のプラットフォーム保護を提供します。",
    "s6.li1": "お支払いは Stripe を通じて安全に処理されます。出品者への支払いは BidNova Auctions の支払いポリシーに従って行われます。",
    "s6.li2": "商品が説明と異なる、破損している、または届かない場合、異議を申し立てることができます。",
    "s6.li3": "管理者がお客様に有利な裁定を下した場合、当社はお客様に返金し、売主から資金を回収します。",
    "s6.li4": "PSA、BGS、CGCのスラブに関する鑑定に係る紛争は、鑑定会社の記録を参照して解決されます。",
    "s7.h": "7. 売主の義務（概要）",
    "s7.p": "売主の義務の詳細は<a href=\"/legal/seller-agreement\">出品者契約</a>に定められています。概要として、売主はすべてのロットを正確に説明し、欠陥を開示し、商品を完全に所有し、迅速に発送し、英国の消費者法および税法を遵守しなければなりません。",
    "s8.h": "8. 禁止される商品および行為",
    "s8.p1": "以下はプラットフォーム上での出品、販売、または宣伝ができません。",
    "s8.li1": "偽造・模造カード、改造されたスラブ、または鑑定ラベルが改ざんされた商品。",
    "s8.li2": "盗品または販売する権利のない商品。",
    "s8.li3": "The Pokémon Company、Nintendo、その他第三者の知的財産権を侵害する商品。",
    "s8.li4": "英国の輸出規制または貿易制裁の対象となる商品。",
    "s8.li5": "武器、薬物、アダルトコンテンツ、その他英国法上違法な商品。",
    "s8.p2": "また、入札の不正操作、他の利用者への嫌がらせ、プラットフォームのスクレイピング、手数料の回避を試みることも禁止されています。",
    "s9.h": "9. 紛争および解決",
    "s9.li1": "買主または売主は、注文ページを通じて問題を書面で記載し、異議を申し立てることができます。",
    "s9.li2": "当該注文について異議申立てが有効な間は、売主への支払いは行われません。",
    "s9.li3": "当社の管理チームは、裁定を下す前に証拠を確認し、双方と連絡を取ります。",
    "s9.li4": "解決策としては、返金、売主への資金の解放、または一部和解が考えられます。",
    "s9.li5": "お客様は、England &amp; Wales裁判所を通じて法定救済を求める権利を保持します。",
    "s10.h": "10. 手数料、税金、および請求書",
    "s10.p": "売主は、付加価値税（VAT）の義務やHMRCへの所得申告を含む自身の税務について責任を負います。当社は、OECDのデジタルプラットフォームに関するモデル報告規則に基づき、HMRCに取引データを共有するよう求められる場合があります。",
    "s11.h": "11. 知的財産",
    "s11.p": "ブランディング、デザイン、コードを含むプラットフォームは、当社またはそのライセンサーが所有しています。当社の書面による同意なしに、プラットフォームの一部を複製、再販、またはリバースエンジニアリングすることはできません。",
    "s12.h": "12. 責任の制限",
    "s12.p": "本規約のいかなる規定も、過失による死亡または人身傷害、詐欺、または英国法上制限できないその他の責任を制限するものではありません。それを条件として、プラットフォームに関連して当社がお客様に対して負う責任の総額は、£100または請求の原因となった事象の発生前12か月間にお客様が当社に支払った手数料の合計額のいずれか高い方を上限とします。",
    "s13.h": "13. 本規約の変更",
    "s13.p": "当社は本規約を随時更新することがあります。重要な変更については、発効の少なくとも14日前に電子メールまたはプラットフォーム上の通知によりお知らせします。発効日以降も引き続き利用することは、変更への同意とみなされます。",
    "s14.h": "14. お問い合わせ",
    "s14.p": "本規約に関するお問い合わせ：<a href=\"mailto:legal@bidnovaauctions.uk\">legal@bidnovaauctions.uk</a>。"
  },
  "privacy": {
    "title": "プライバシーポリシー",
    "intro": "BidNova Auctions Ltd（以下「当社」）は、お客様がbidnovaauctions.uk（以下「本プラットフォーム」）を利用する際に提供される個人データの管理者です。当社は、UK GDPR、Data Protection Act 2018、およびPrivacy and Electronic Communications Regulations（PECR）に従って個人データを処理します。",
    "s1.h": "1. 当社が収集するデータ",
    "s1.li1": "<strong>アカウントデータ：</strong>氏名、メールアドレス、パスワード（ハッシュ化）、表示名、アバター。",
    "s1.li2": "<strong>本人確認データ：</strong>高額取引を行う売主については、身分証明書類および住所確認情報。",
    "s1.li3": "<strong>取引データ：</strong>入札、購入、販売、注文履歴、追跡番号、配達確認、紛争記録。",
    "s1.li4": "<strong>決済データ：</strong>Stripe Payments UK Ltdが処理し、当社はメタデータ（下4桁、ブランド、国）のみを受け取り、カード情報全体を取得することはありません。",
    "s1.li5": "<strong>技術データ：</strong>IPアドレス、デバイス／ブラウザ情報、タイムスタンプ、セッションCookie（詳細は<a href=\"/legal/cookies\">Cookieポリシー</a>をご覧ください）。",
    "s1.li6": "<strong>通信内容：</strong>お客様が本プラットフォームを通じて当社または他の利用者に送信するメッセージ。",
    "s2.h": "2. 当社によるデータの利用方法および法的根拠",
    "s2.li1": "<strong>プラットフォームの提供</strong>（第6条1項(b) — 契約の履行）：アカウント管理、入札、注文処理、支払い、支払いの実行、紛争対応。",
    "s2.li2": "<strong>不正防止およびプラットフォームの安全確保</strong>（第6条1項(f) — 正当な利益）：サクラ入札、模造品の出品、不正なチャージバックの検知。",
    "s2.li3": "<strong>法令および税務上のコンプライアンス</strong>（第6条1項(c)）：AMLチェック、HMRCへのデジタルプラットフォーム報告、裁判所／ICOの命令への対応。",
    "s2.li4": "<strong>サービスに関する連絡</strong>（契約）：オークション結果、支払い領収書、紛争の更新情報、セキュリティ警告。",
    "s2.li5": "<strong>マーケティング</strong>（第6条1項(a) — 同意）：販促メール。いつでも配信停止が可能です。",
    "s3.h": "3. データの共有先",
    "s3.li1": "完了した取引の売主および買主（配送に必要な情報に限定）。",
    "s3.li2": "当社の決済処理業者であるStripe Payments UK Ltd。",
    "s3.li3": "当社の処理者として機能するクラウドインフラおよびメールサービスの提供業者。",
    "s3.li4": "法律上必要な場合のHMRCおよびその他の当局。",
    "s3.li5": "守秘義務のもとで対応する専門アドバイザー。",
    "s3.p": "当社がお客様の個人データを販売することは一切ありません。",
    "s4.h": "4. 国際移転",
    "s4.p": "個人データを英国外に移転する場合、当社はUK International Data Transfer Agreement（IDTA）、EU標準契約条項に対する英国附則、または十分性認定のいずれかに依拠します。",
    "s5.h": "5. データの保存期間",
    "s5.li1": "アカウントデータ：アカウントが有効な間、および閉鎖後も税務・法的記録のため6年間。",
    "s5.li2": "取引および支払い記録：英国税法に従い6年間。",
    "s5.li3": "マーケティングに関する設定：同意を撤回するまで。",
    "s5.li4": "紛争に関する証拠：解決から6年間。",
    "s5.li5": "広告分析：個別のバナー表示およびクリック記録は仮名化され（生のIPアドレスではなく一方向ハッシュを保存します）、90日後に自動的に削除されます。それ以降は、広告主への報告のために表示回数、クリック数、ユニーク訪問者数といった匿名の日次合計のみが保持されます。広告分析は、お客様が分析用Cookieに同意した場合にのみ収集され、ご要望に応じてキャンペーンの生データを削除することも可能です。",
    "s6.h": "6. UK GDPRに基づくお客様の権利",
    "s6.li1": "アクセス権 — 当社が保有するお客様の個人データの写しを請求する権利。",
    "s6.li2": "訂正権 — 不正確なデータの訂正を求める権利。",
    "s6.li3": "消去権 — データの削除を求める権利（法定の保存義務に従います）。",
    "s6.li4": "制限権および異議権 — 特定の処理を制限し、または異議を述べる権利。",
    "s6.li5": "データポータビリティの権利 — 構造化され機械判読可能な形式でデータを受け取る権利。",
    "s6.li6": "いつでも同意を撤回する権利（撤回前の適法な処理には影響しません）。",
    "s6.li7": "英国情報コミッショナー事務局（ICO）への苦情申立て — <a href=\"https://ico.org.uk\" target=\"_blank\" rel=\"noreferrer\">ico.org.uk</a>。",
    "s6.p": "権利を行使する場合は、<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>までメールでご連絡ください。1か月以内に対応いたします。",
    "s7.h": "7. セキュリティ",
    "s7.p": "当社はすべての通信にTLSを使用し、最新のハッシュ技術によりパスワードを暗号化し、アクセス制御を実施し、不審な活動を監視しています。完全に安全なシステムは存在しません — お客様の権利に対するリスクを生じさせる可能性のある個人データ侵害を認識した場合、当社は72時間以内にICOへ通知し、必要な場合はお客様にも通知します。",
    "s8.h": "8. 児童",
    "s8.p": "本プラットフォームは18歳未満の方を対象としておらず、当社は児童のデータを意図的に収集することはありません。",
    "s9.h": "9. 変更",
    "s9.p": "本ポリシーの重要な変更については、メールまたはプラットフォーム上の通知によりお知らせします。",
    "s10.h": "10. お問い合わせ",
    "s10.p": "データ管理者：BidNova Auctions Ltd（England &amp; Walesにて登録）。お問い合わせ先：<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>。"
  },
  "cookies": {
    "title": "Cookieポリシー",
    "intro": "本Cookieポリシーは、BidNova Auctions Ltdがbidnovaauctions.ukにおいてCookieおよび類似の技術をどのように利用しているかを説明するものです。本ポリシーは<a href=\"/legal/privacy\">プライバシーポリシー</a>と併せてお読みください。Cookieは英国においてPrivacy and Electronic Communications Regulations（PECR）およびUK GDPRにより規律されます。",
    "s1.h": "1. Cookieとは",
    "s1.p": "Cookieとは、ウェブサイトを訪問した際にお客様のデバイスに保存される小さなテキストファイルです。Cookieにより、サイトは一定期間にわたりお客様の操作や設定（ログイン状態の維持など）を記憶することができます。",
    "s2.h": "2. 当社が使用するCookie",
    "s2.h3a": "必須Cookie（同意不要）",
    "s2.li1a": "<strong>セッションおよび認証：</strong>ログイン状態を維持し、セッションの安全性を確保します。",
    "s2.li2a": "<strong>セキュリティトークン：</strong>CSRFや不正利用を防止します。",
    "s2.li3a": "<strong>負荷分散：</strong>リクエストを適切なサーバーへ振り分けます。",
    "s2.h3b": "機能Cookie（有効化された場合にのみ使用）",
    "s2.li1b": "<strong>設定：</strong>テーマなどの表示設定を記憶します。",
    "s2.li2b": "<strong>ウォッチリストの状態：</strong>訪問間でお客様がウォッチしているオークションを記憶します。",
    "s2.h3c": "分析Cookie（オプトイン）",
    "s2.li1c": "本プラットフォームの改善に役立つ、プライバシーに配慮した集計分析データです。",
    "s2.li2c": "これらはCookieバナーを通じて同意いただいた場合にのみ設定されます。",
    "s2.h3d": "第三者Cookie",
    "s2.li1d": "<strong>Stripe：</strong>チェックアウトページにおける不正防止（決済上必須のCookie）。",
    "s2.li2d": "<strong>Google（利用時）：</strong>「Googleで続ける」を選択してサインインする場合にのみ使用されます。",
    "s3.h": "3. お客様の選択",
    "s3.li1": "Cookieバナーを通じて、必須ではないCookieの受け入れまたは拒否を選択できます。",
    "s3.li2": "ブラウザの設定でCookieを削除またはブロックできますが、必須Cookieを無効にすると、入札やチェックアウトなどの主要機能が利用できなくなります。",
    "s3.li3": "サイトデータを削除して再度訪問することで、いつでも設定を変更できます。",
    "s4.h": "4. Do Not Track（トラッキング拒否）",
    "s4.p": "「Do Not Track」信号については業界共通の標準が存在しないため、当社の本プラットフォームは現在これに対応していません。",
    "s5.h": "5. 変更",
    "s5.p": "Cookieの利用方法を変更する場合、本ポリシーを更新いたします。定期的にご確認ください。",
    "s6.h": "6. お問い合わせ",
    "s6.p": "ご質問は<a href=\"mailto:privacy@bidnovaauctions.uk\">privacy@bidnovaauctions.uk</a>までご連絡ください。"
  }
}
